<template>
  <article class="layout-section -bg-shade -alt-top">
    <div class="layout-section__hgroup">
      <h3 class="layout-section__title -small -no-space">Groupe 4</h3>
      <p>Membres individuels</p>
    </div>

    <section class="layout-grid">
      <div class="layout-grid__item card -smaller">
        <p>Contenu à venir</p>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutMembersIndex2'
}
</script>
